import { render, staticRenderFns } from "./TIPO_RODAPE.vue?vue&type=template&id=63d06c9b"
import script from "./TIPO_RODAPE.vue?vue&type=script&lang=js"
export * from "./TIPO_RODAPE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports